import { Children } from "./v1";

export const childrenOptions = Object.entries(Children)
	.filter(([value]) => {
		return isNaN(Number(value));
	})
	.map(([value, label]) => {
		return { value, label };
	});
